export const LOGIN = "LOGIN";
export const SIGN_OUT = "SIGN_OUT";
export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGIN_ACTION_HIDE = "LOGIN_ACTION_HIDE";
export const IS_DISABLE = "IS_DISABLE";
export const LOGIN_FN = "LOGIN_FN";
export const IGNORE = "IGNORE";



// WEBPACK FOOTER //
// ./src/redux/type/User.type.js